import React from "react";
import CarHero from "./car-hero/CarHero";
import MainContent from "./main-content/MainContent";
import useInitCustomize from "../../../hooks/customize/useInitCustomize";

const CustomizeContainer = (): JSX.Element => {
    useInitCustomize();
    return (
        <>
            <CarHero />
            <MainContent />
        </>
    );
};

export default CustomizeContainer;
